import { Color, Flex, Spacing, Text } from '@billy/design-system'
import { ReactElement, ReactNode } from 'react'

interface ColumnHeaderWithUnitProps {
  label: ReactNode
  unit: string
}

export const ColumnHeaderWithUnit = ({ label, unit }: ColumnHeaderWithUnitProps): ReactElement => (
  <Flex gap={Spacing.S4} alignItems="center">
    <Text weight="medium" color={Color.Grey950}>
      {label}
    </Text>
    <Text color={Color.Grey500}>{unit}</Text>
  </Flex>
)
